import CathayMRRouter from "app-router/cathaymr/cathaymr-router";

export default CathayMRRouter
